import apiFetch from '../../apiFetch'

export default function (token, purchaseId, saleId, parentIsHistorical, lastAccessDate) {
  return apiFetch({ endPoint: `dossier/purchase/${purchaseId}/reassignToSale/${saleId}?parentIsHistorical=${parentIsHistorical}`, method: 'PUT', body: null, token: token, lastAccessDate })
}
